/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".child-forms-container[_ngcontent-%COMP%]{border-left:20px solid #19a0b7;border-bottom:20px solid #19a0b7;padding-left:10px;margin-bottom:10px}"];
export { styles as styles };
